export default {
  'booksy-app': {
    'search': 'Search Booksy App',
  },
  search: 'Search in Business Settings...',
  in: 'in',
  modals: {
    'add-category-modal': {
      'add-title': 'Add Category',
      'edit-title': 'Edit Category',
      'category-name': 'Category name',
    },
    'suspend-account': {
      'title': 'Suspend my account',
      'text-1': "Things change and sometimes you just need a break. We get that. We're sad to see you go, but hope you return before too long.",
      'text-2': "Remember, while your Booksy account is suspended your profile will not show on the marketplace and customers won't be able to book you through the app. Changes will take effect at the beginning of your next monthly billing cycle.",
      'text-3': "Once the suspension period is over your subscription will renew automatically. And, if your choose to come back sooner, we'd love to have you. Simply reverse the suspension and you're back in business.",
      'label': 'Suspend my account for:',
    },
  },
  details: {
    search: 'Search in Business Details...',
    category: {
      'type-of-business': 'What type of business are you?',
      'additional-categories': 'Additional Categories',
      'main-category': 'Main Category',
      'add-category': 'Add Category',
      'add-additional-category': 'Add Additional Category',
      'hint': 'Your business category describes your line of work and the services you offer. To help customers find you, choose a main category that accurately reflects what you do. You can always change it later.',
      'additional-categories-select': {
        'select-categories': 'Select the categories you would like to be listed',
      },
    },
    'opening-hours': {
      'opening-hours-note': 'Business Hours Note',
      'edit': 'Edit',
      'add-note': 'Add Note',
      'apply-changes-starting': 'Apply changes starting',
      'choose': 'Choose',
      'opening-hours-applied-date': 'New business hours will be applied on {date}',
      'check-and-edit-shifts': 'Check & edit your team’s shifts',
      'go-to-shifts': 'Go to shifts',
      'hint': 'The changes you are about to save will replace opening hours change scheduled on {date}',
      'warning-title': 'Adjust Opening Hours?',
    },
    'custom-forms-list': {
      'title': 'Custom Forms',
      'hint': 'Here is where you can create a custom form. You can require your customers to sign these before services that might have risks or side effects.<br><br>To create your form, you can input the wording you currently use or use sample forms commonly used in your industry. Since these forms are designed to protect you and your business, consider having your attorney take a look.<br><br>Forms like this are commonly used for services such as laser treatments, massages, facials, personal training, physical therapy and other similar services.',
    },
    'custom-forms': {
      'list': {
        'empty-list': 'No custom forms added yet.',
      },
      'list-item': {
        'zero-services': 'Not required (services not selected)',
        'all-services': 'All services',
        'services': 'Services',
      },
      'form': {
        'customize-form': 'Customize Form',
        'required-at-every-appointment': 'Required at every appointment',
        'required-at-every-appointment-desc': 'The client will have to fill in and sign the document before each appointment',
        'required-at-first-appointment': 'Required for first appointment',
        'required-at-first-appointment-desc': 'The client will only have to sign the form the first time they receive that service.',
        'title': 'Title',
        'required-for': 'Required for',
        'select-services': 'Select services',
        'selected-services': 'Selected services',
        'all-services': 'All services',
        'paragraph': 'Paragraph',
        'checkbox': 'Checkbox',
        'text-field': 'Text Field',
        'add-paragraph': 'Add Paragraph',
        'add-checkbox': 'Add Checkbox',
        'add-text-field': 'Add Text Field',
        'add-text-or-field': 'Add Text or Field',
      },
      'input-field-modal': {
        'label': 'Field Label',
        'add-field': 'Add Field',
        'edit-field': 'Edit Field',
      },
      'checkbox-field-modal': {
        'label': 'Checkbox Label',
        'add-field': 'Add Checkbox',
        'edit-field': 'Edit Checkbox',
      },
      'text-field-modal': {
        'label': 'Paragraph',
        'add-field': 'Add Paragraph',
        'edit-field': 'Edit Paragraph',
      },
      'shared': {
        'custom-form-required-modal': {
          'title': 'Custom Form Required',
          'description': 'This client has not signed the required form(s) yet. You can add documentation now, or proceed without it.',
          'send-the-request-to-client': 'send the request to client',
          'upload-signed-document': 'Upload Signed Form',
          'file-uploaded': 'File successfully uploaded',
          'document-preview': 'Document Preview',
          'choose-another-photo': 'Choose another photo',
          'cancel': 'Continue without form',
        },
        'custom-form-preview-modal': {
          'title-preview': 'Form Preview',
          'title-details': 'Form Details',
          'clients-signature': 'client\'s signature',
          'download-pdf': 'Download as PDF file ',
          'send-by-email': 'Send to my email address',
          'custom-form-sent': 'Custom Form Sent',
          'click-here-to-sign': 'Click here to sign',
        },
        'custom-form-photo-modal': {
          'title': 'Document Preview',
        },
      },
    },
    'cover-image': {
      title: 'Cover photo',
    },
  },
  'logo-cropper': {
    'cropper-text': 'Fit your image to a circle. Zoom by multi-touch gestures. <br/> Make sure that your face or logo looks clear.',
  },
  'photo-cropper': {
    'cropper-text': 'Adjust the size of the grid to crop your image. You can also drag your photo to reposition it.',
  },
  'business-info-form': {
    'left-title': 'General Info',
    'right-title': 'Social Media',
    name: 'Business name',
    phone: 'Business phone number',
    email: 'Business owner’s email',
    'public-email': {
      label: 'Business email',
      hint: 'If you do not add a business email, the business owner\'s email will be displayed on your profile.',
    },
    description: 'Short description of your business (recommended)',
    website: 'Website',
    'online-shop': 'Online shop',
    'subdomain': 'Link to your public profile',
    'subdomain-min-length': 'This field must be at least 4 characters.',
    'subdomain-hint': 'A short, memorable link to your Booksy profile.',
    'tax-info': 'Tax Info',
    'your-tax-info': 'Your Tax Info',
    'add-tax-info': 'Add Tax Info',
    'tax-id': 'Tax ID',
    'delete-modal-header': 'Delete Tax Info?',
    'delete-modal-content': 'This action cannot be undone',
  },
  'business-seller-form': {
    'inv': 'INV',
    'cor': 'COR',
    'rr': 'RR',
    'rd': 'RD',
    'name': 'Company Name',
    'tax-id': 'Tax ID',
    'address': 'Address',
    'city': 'City',
    'post-code': 'Post code',
    'country': 'Country',
    'invoice-prefix': 'Invoice Prefix',
    'correction-prefix': 'Correction Prefix',
    'prefix-cash-in': 'Prefix Cash In',
    'prefix-cash-out': 'Prefix Cash Out',
    'bank-name': 'Bank Name',
    'account-number': 'Account Number',
    'state': 'State',
    'voivodeship': 'Voivodeship',
    siren: 'SIREN',
    siret: 'SIRET',
    naf: 'NAF (APE) code',
    'top-banner-text': 'The below tax info has been used on at least one transaction. If you want to change the details, please contact our Customer Support.',
  },
  photos: {
    'add-logo': {
      title: 'Logo',
      subtitle: 'Upload your business logo so it\'s visible on your Booksy Profile.',
      add: 'Add Logo',
      'modal-title': 'Delete Logo?',
      'modal-description': 'This cannot be undone',
      'logo-uploaded': 'Logo uploaded!',
      'logo-deleted': 'Logo deleted!',
      'cropper-title': 'Adjust',
      'cropper-description': 'Use your finger or mouse to reposition your image so it fits within the circle.<br/> Also make sure the image looks clear.',
      upload: 'Upload New Logo',
      remove: 'Delete Logo',
    },
    'venue-photos': {
      title: 'Workplace photos',
      subtitle: 'Give clients a sneak peek of your space before they even walk through the door.',
      'add-media': 'Add media',
      'pick-button': 'Set as a cover photo',
      'cropper-title': 'Adjust',
      'cover-cropper-title': 'Adjust',
      'cropper-text': 'Adjust the size of the grid to crop your image. You can also drag your photo to reposition it.',
      'photo-uploaded': ' Workplace photos uploaded!',
      'photo-deleted': ' Workplace photos deleted!',
    },
    'cover-photo': {
      title: 'Cover Photo',
      subtitle: 'Your cover photo is the first thing that your customers see on your Booksy Profile. Add a photo to give them insight into what you’re all about.',
      'add-media': 'Add media',
      'pick-button': 'Set as a cover photo',
      'modal-title': 'Delete cover photo?',
      'modal-description': 'You are about to delete a photo which is assigned as your cover photo. Make sure you set another photo as you cover photo.',
      uploaded: 'Cover photo uploaded!',
      upload: 'Upload Cover Photo',
      remove: 'Delete Cover Photo',
      deleted: 'Cover photo deleted!',
    },
  },
  'venue-and-location': {
    'business-location': {
      'title': 'Business location',
    },
    'workplace': {
      'title': 'Workplace',
      'at-my-place': {
        'title': 'At my place',
        'info': 'Clients come to the business, such as your own place, a salon, or a suite where other professionals work.',
      },
      'mobile-service': {
        'title': 'At the client\'s location',
        'info': 'Services are performed at the client\'s location.',
      },
    },
    'ttc-type': {
      title: 'I work',
      'no-ttc-desc': 'At my place only',
      'mixed-ttc-desc': 'At my place and client\'s location',
      'ttc-only-desc': 'At my client\'s location only',
    },
    'location-edit': {
      'search': {
        'title': 'Edit location',
        'subtitle': 'If you’re on Google, search your business name.',
      },
      'confirm': {
        'title': 'Confirm location',
      },
    },
    'address': {
      title: 'Address',
      'edit-btn': 'edit',
      'cant-find': 'Can’t find address? Add it here',
      'cant-find-placeholder': 'We can\'t find this address',
      'cant-find-placeholder-desc': 'Make sure you spelled it correctly',
    },
    'geolocation': {
      'rejected-title': 'We can’t localize you',
      'rejected-text': 'We are not able to get access to your location. <br> We use your location to localize your positon on map. <br>To enable location please change your browser settings.',
      'rejected-btn': 'TURN ON LOCATION ACCESS',
    },
    'change-location': {
      'title': 'Change location?',
      'text': 'You are about to change your business’ address. In the next step, you will have to add new location of your business.',
    },
    'join-venue': {
      'title': 'Do you work here?',
      'text': 'If so your Booksy profile will be linked to this location. You\'ll also have a separate page for your solo business. Clients can use either to find you and get on your books.',
      'yes': 'yes, i work here',
      'no': 'NO, I WORK SOMEWHERE ELSE',
      'suite-number': 'Apartment, room or suite number (optional)',
    },
    'hide-location': {
      title: 'Hide my address',
      description: 'Your address will not be visible on your profile.',
      off: 'Not Visible',
      on: 'Visible',
    },
    'mobile-services': {
      title: 'Mobile services',
      'travel-fee': 'Travel fee',
    },
    map: {
      title: 'Map Location',
      'adjust-map-btn': 'adjust map',
    },
    'pick-ttc': {
      title: 'Where Do You Work?',
      desc: 'Do you work in a salon/shop or do you provide mobile services?',
      'no-ttc': 'At my place only',
      'no-ttc-desc': 'I work at my place only. I own the place or I work with other independent pros at salon or suite.',
      'mixed-ttc': 'At my place and client’s location',
      'mixed-ttc-desc': 'I work at my place, but some of my services are at my client’s location.',
      'only-ttc': 'At my client\'s location only',
      'only-ttc-desc': 'All my services are at my client’s location. I\'m a mobile specialist traveling to clients.',
    },
    'ttc-confirm-modal': {
      titles: {
        'turned-off': 'Mobile Services Turned Off',
        'turned-on': 'Mobile Services Turned On',
        'mobile-services': 'Mobile Services Setup',
      },
      body: {
        'turned-off': 'You selected "At my place only," which means all of your services will be available at your place only. Mobile Services will be turned off',
        'mixed-from-turned-off': 'Since you\'re planning to travel to clients, we\'ll need a bit more information. Complete your Mobile Services setup to enter your traveling fee, set your travel distance, and include your policies. Once complete you\'ll be able to choose which services you want to offer as Mobile Services.',
        'ttc-only-from-mixed': 'You selected "At client\'s location only," meaning all of your services will be available only at the client\'s location.',
        'ttc-only-from-turned-off': 'As a business traveling to clients, you have to enter your minimum traveling fee, travel distance, and lay out your policy. You selected "At client\'s location only," meaning all of your services will be available only at the client\'s location.',
      },
      buttons: {
        'no-btn': 'OOPS, NO',
        'ok-btn': 'OK, CONTINUE',
      },
    },
    'ttc-address-form': {
      title: 'Your Address',
      desc: 'Where can clients find you?',
      'street-address-and-number': 'Street address line 1',
      'apartament-or-suite-number': 'Street address line 2',
      'city': 'City',
      'zip-code': 'Zip Code',
      'reset': 'reset',
    },
    'travel-fee': {
      title: 'Travel Fee',
      desc: 'Add your minimum travel fee.',
      'travel-fee': 'travel fee',
      'price-type': 'price type',
      'price': 'Price',
      'maximum-travel-distance': 'maximum travel distance',
      'maximum-travel-distance-short': 'Max. travel distance',
      'travel-and-fee-policy': 'Travel & Fee Policy (optional)',
      'hint': 'Here you can list details about travel fees such as mileage, transit time, and parking. You can also let clients know how far you’re willing to travel for appointments.',
    },
    'travel-fee-policy-modal': {
      title: 'Travel & Fee Policy',
      desc: 'travel & fee policy',
      hint: 'Here you can further describe your travel policy. For example, which neighborhoods are you willing or not willing to travel to? Will you charge extra for traveling a certain distance? Will there be additional fees for parking or tools? Is anything required on the client\'s end that is necessary for you to successfully perform your service?',
    },
    'map-location': {
      title: 'Map Location',
      'modal-title': 'Update your address?',
      'modal-content-one': 'You\'ve set your location to',
      'modal-content-two': 'Do you want to update your address to match this location?',
      yes: 'yes',
      no: 'no, thanks',
      tooltip: 'Move the map under the stationary location until it is positioned correctly.',
    },
  },
  'umbrella-venue': {
    'edit': 'Edit',
    'venue-address': 'My Address',
    'suite-number': 'Apartment, room or suite number (optional)',
    'leave-umbrella': 'Leave this venue',
    'leave-confirm': {
      'title': 'Are you sure?',
      'text': 'You are about to leave the venue. You will continue to select your new address.',
    },
    'confirm': {
      'are-u-sure': 'Are you sure?',
      'text': 'You are about to update the venue details. This change will affect you and other professionals working with you at this venue.',
      'update': 'Update the venue detailss',
    },
    'edit-venue': {
      'title': 'Edit Shared Location',
      'updated': 'Venue Updated:',
      'name': 'What is the name of the venue?',
    },
  },
  payments: {
    'search-placeholder': 'Search in Payment Types...',
    'booksy-pay': {
      'fee-banner': {
        'description': 'You will receive the full payment amount when clients use Booksy Pay. ',
        'label': 'Booksy Pay fee',
        'title': 'Free for 12 months',
      },
      'get-help': {
        'btn-help-center': 'Go to Help Center',
        'contact-support': 'contact our support',
        'description': 'If you want to turn Booksy Pay off, please {contact-support} or go to the Booksy Biz Help Center to learn more about Booksy Pay.',
        'title': 'Get help',
      },
      'how-it-works': {
        'description': 'With Booksy Pay active, clients can choose to pay with their preferred payment method when booking an appointment or after the service.',
        'step-1': 'A special badge shows your business accepts Booksy Pay for using methods such as Apple Pay, Google Pay, or Klarna.',
        'step-2': 'Clients can use Booksy Pay when they book. They can still choose to pay at the appointment.',
        'step-3': 'On your calendar, Booksy Pay appointments are marked with a dollar sign.',
        'step-4': 'You will receive your funds the next business day after the payment is made. You can check the details in your Business Wallet.',
        'title': 'How it works',
      },
      'options': {
        'cancellation-window': 'Set cancellation window for refunds.',
        'social-post': 'Share a social post to let clients know about your new flexible payment options.',
        'title': 'Options to increase your Booksy Pay bookings and earnings',
        'tips': 'Turn on tips so clients can add a tip through Booksy.',
        'tips-status': {
          'active': 'Active',
          'inactive': 'Inactive',
        },
      },
      'payment-methods': {
        'description': 'Payment methods for bookings',
      },
      'refunds': {
        'title': 'How refunds work with Booksy Pay',
        'description': 'Refunds work differently depending on when clients cancel inside or outside your window.',
        'on-time-cancellations': {
          'title': 'On-time cancellations',
          'description': 'If a client cancels a prepaid appointment before your late cancellation window, the refund is processed automatically.',
          'instructions': [
            'The refund amount will be deducted from your Booksy Payments balance.',
            'You\'ll find a complete history of refunds in your Booksy Wallet transaction list.',
            'We\'ll send you a push notification once the refund is complete. On the receipt, automatic refunds will be marked as “Processed by system”.',
          ],
        },
        'late-cancellations': {
          'title': 'Late cancellations',
          'description': 'If a client cancels within your late cancellation window, you decide whether to issue a refund.',
          'instructions': [
            'When clients cancel late, they’re notified that you\'ll decide on the refund.',
            'You’ll get a push notification about the client\'s refund request.',
            'You can approve the refund from the receipt in appointment details – select the cancellation notification to go to the receipt. You have 30 days from the request to make a decision.',
          ],
        },
        'late-cancellation-window': {
          'title': 'Cancellation window for refunds',
          'description': 'Define how far in advance clients need to cancel to receive an automatic refund.',
          'label': 'Cancellation window',
          'save': 'Save',
          'success-message': 'Cancellation window set',
        },
      },
    },
  },
  'personal': {
    'search': 'Search in Personal Settings...',
    'sign-in-methods': {
      'your-email': 'Your email address:',
      'connect-google': 'Connect your account with Google',
      'connect-facebook': 'Connect your account with Facebook',
      'connect': 'Connect',
      'connected': 'Connected',
      'title': 'Connect your social accounts to sign in faster',
    },
  },
  'search-visibility': {
    title: 'Search Visibility',
    subtitle: 'Let clients find you when they search for a service on Booksy.',
  },
  'online-booking': {
    'tools-description': 'Make it as easy as possible for clients to book appointments with you. These tools do just that.',
    title: 'Online Booking',
    'new-title': 'Prefer the hard way?',
    subtitle: 'Go offline and don\'t allow your clients to book visits online 24/7',
    'booksy-partners': 'Booksy Partners',
    'enable-button': 'Enable online booking',
    header: 'Booksy Customer App',
    subheader: 'Your clients can book and manage their appointments online.',
    'banner-subtitle': 'Enable online booking to say goodbye to interruptions, no-shows, and working after hours.',
    'off-head-part-1': 'Ready to Get More Clients?',
    'off-head-part-2': 'Turn On Online Booking',
    'off-description-part-1': 'Online booking is now disabled. The booking process will be more difficult for your clients since they can\'t book 24/7 through Booksy, Instagram, Google or your website. Your business is also not visible in the Booksy client app or the Booksy website.',
    'off-description-part-2': 'Turn on online booking so new clients can find you and existing clients can book 24/7 from Booksy, Instagram, Google or your website. No more need to interrupt you just to set a date.',
    instagram: 'Instagram',
    'instagram-description': 'Turn your followers into bookings by adding<br/>a "BOOK" button to your profile.',
    'instagram-book-now-description': 'Turn your followers into bookings by adding a "Book Now" button to your profile',
    'google': 'Reserve with Google',
    'google-description': 'Let clients book and manage their appointments online.',
    'yelp': 'Yelp',
    'yelp-description': 'Allow clients to book an appointment directly from your Yelp profile.',
    'your-website': 'Your Website',
    'your-website-description': 'Easily add a Book button to your website',
    'facebook': 'Facebook',
    'facebook-description': 'Allow your fans to book an appointment<br/>directly from your Facebook page.',
    toasts: {
      enabled: 'Activated',
      disabled: 'Disabled',
    },
    'integration-status': {
      active: 'Active',
      inactive: 'Inactive',
      suspended: 'Suspended',
      blocked: 'Blocked',
    },
  },
  'disable-online-bookings': {
    title: 'Disable Online Booking?',
    'description-part-1': 'Clients will no longer be able to book with you via Booksy, Instagram, Facebook, or Google.',
    'description-part-2': 'You\'ll still be able to use Booksy to manage you business, but you\'ll need to add clients to your calendar manually. Are you sure?',
  },
  'cannot-disable-online-bookings': {
    title: 'You can\'t go offline now',
    'description-part-1': 'You have outstanding client invites so you can\'t go offline at this time.',
    'description-part-2': 'You\'ll be able to go offline 3 days after your last invite is sent.',
  },
  'go-offline': {
    title: 'Are you sure you want to go offline?',
    'description-part-1': 'If you go offline it means new clients won\'t find you and returning clients may have a hard time finding your Business Profile to book their next appointment.',
    'description-part-2': 'Did you know approximately 40% of bookings are made outside of normal business hours? Disabling online booking means you\'ll go back to spending your evenings and days off taking calls from clients, or missing out on the appointment entirely.',
    'description-part-3': 'Are you sure you want to do this?',
    'confirm-button': 'Go offline',
  },
  'hide-your-business': {
    title: 'Hide Your Business',
    'description-part-1': 'If you disable Search Visibility, your profile will be hidden from NEW clients on Booksy. They will not see your Business Profile in search results, even if you\'re exactly what they\'re looking for.',
    'description-part-2': 'Your existing clients with Booksy accounts will still be able to find your profile in their appointment history in the Booksy Client app or with the unique link to your Business Profile.',
    'description-part-3': 'Search Visibility will be disabled for 7 days.',
    'customer-support': 'Customer Support.',
    'confirm-button': 'Hide me from new clients',
  },
  'hide-your-business-with-boost': {
    'description-part-1': 'You currently have Boost enabled so your profile ranks higher in Booksy search results. If you disable Search Visibility, your profile will be hidden on Booksy and will no longer be in the top positions in search results.',
    'description-part-2': 'Clients with Booksy accounts will still be able to find your profile in their appointment history, on the list of their favorite businesses in the app, and through the link to your Business Profile.',
  },
  'not-ready-business': {
    title: 'Not Quite Ready Yet',
    'description-part-1': 'Before we share your Booksy Business Profile, there are a few more steps to take.',
    'description-part-2': 'Add at least one service to your Services and allow clients to book it online',
    'description-part-3': 'Connect at least one Staff Member to the service',
    'description-part-4': 'Enable Online Booking for at least one Staff Member',
    'services-button': 'Go to services',
    'staff-button': 'Go to staff members',
    'not-now-button': 'Not now',
  },
  'no-show-protection': {
    'title': 'No-Show Protection',
    'delete-prepayment': 'Delete Deposit Rule',
    'delete-cancellation-fee': 'Delete Cancellation Fee',
    'valid-for': 'Valid for',
    'apply-to-services': 'Apply to services',
    'apply-to-services-title': 'Apply to Services',
    'missing-pricing': 'Percentage rules require fixed prices',
    'missing-pricing-text': 'Some services included in this rule have price type set to "varies", "free", or "don\'t show". We cannot calculate a percentage for these price types.<br><br>You can edit the rule and switch to a fixed amount, or save for eligible services only. Non-eligible services will be removed from this rule.',
    'apply-for-services': 'Save for eligible services',
    'edit-rule': 'Edit rule',
    'adjust-pricing': 'Adjust service pricing',
    'rules': 'Rules',
    'prepayment-value': 'Deposit · {value}',
    'cancellation-fee-value': 'Cancellation Fee · {value}',
    'services-length': '{count} Service | {count} Services | {count} Services',
    'add-rules': 'Add Rules',
    'clear-rules-button': 'Clear all rules ({count})',
    'clear-deposit-rules': 'Clear all Deposit rules',
    'clear-deposit-rules-description': 'Clearing all rules means clients will no longer pay a deposit when booking. Are you sure you want to remove this protection?',
    'clear-cancellation-fee-rules': 'Clear all Cancellation Fee rules',
    'clear-all-rules-title': 'Clear All Rules?',
    'clear-all-rules-description': 'Deposits and Cancellation Fees are designed to help you protect your revenue - even when customers don\'t show up. Are you sure you want to clear all rules?',
    'less-for-following-services': 'It is less for following services:',
    'heads-up': 'Heads Up!',
    'minimal-payment': 'Minimum payment amount can’t be less than {count}.',
    'invalid-services': 'There is {count} service that doesn\'t comply with this rule. | There are {count} services that don’t comply with this rule. | There are {count} services that don’t comply with this rule.',
    'would-you-apply': 'Would you like to apply the rule only to qualifying services?',
    'dashboard': {
      'prepayments': 'Deposits',
      'cancellation-fees': 'Cancellation fees',
      'cancellation-policy': 'Cancellation policy',
      'trusted-clients': 'Trusted clients',
    },
    'delete-rule-modal': {
      'title': 'Delete Rule?',
      'deposit-description': 'Deleting this rule means clients will no longer pay a deposit for the services it currently covers. Are you sure you want to remove this protection?',
      'cancellation-fee-description': 'Deleting this rule means you will lose the option to charge a cancellation fee for services it currently covers. Are you sure you want to remove this protection?',
    },
    'rule-overwrite-conflict': {
      'title': 'Existing rules found',
      'description': 'Some services you\'ve selected already have a rule applied. Applying this new rule will replace it.',
      'question': 'Do you want to apply the new rule and replace the existing ones on these services?',
      'apply-and-replace': 'Apply and replace',
      'edit-selection': 'Edit selection',
    },
    'price-lower-than-rule': {
      'title': 'Fee higher than some service prices',
      'description': 'For some of your selected services (x), this rule sets a fee that is higher than their actual price.<br><br> If you proceed, this rule will be applied with the full calculated fee. You will then need to manually reduce the charge at checkout or refund the difference to your client.',
      'question': 'Are you sure you want to apply this rule and manage these adjustments yourself?',
      'apply-and-replace': 'Confirm and manage manually',
      'edit-selection': 'Edit selection',
    },
    'discard-changes-modal': {
      'title': 'Discard changes to Deposit rule?',
      'title-cancellation-fee': 'Discard changes to Cancellation Fee rule?',
      'description': 'If you leave without saving, your changes to this rule will be lost.',
      'question': 'Are you sure you want to discard changes?',
      'discard-changes': 'Discard changes',
      'keep-editing': 'Keep editing',
    },
    'cancellation-fees': {
      'cancellation-fee': 'Cancellation fee',
      'cancellation-fee-description': 'When clients book you online, they will add their credit card on file. If a client cancels last minute or misses the appointment, you can charge the cancellation fee.',
      'you-can-charge': 'You can charge',
      'of-service': 'Of service in case of no-show',
      'edit-cancellation': 'Edit Cancellation Fee Rule',
      'cancellation-fee-rule': 'Cancellation Fee Rule',
      'deadline-for-cancellation': 'Deadline for cancellation to avoid a fee',
      'time-in-advance': 'Time in advance',
      'charge-cancellation-fees': 'Charge Cancellation Fees automatically',
    },
    'prepayments': {
      'prepayment': 'Deposit',
      'prepayment-description': 'When clients book you online, they will pay partial or the full price of the service upfront. The deposit will be deducted from total on checkout.',
      'client-pays': 'Client pays',
      'of-service': 'Of the service price upfront',
      'edit-prepayment': 'Edit Deposit Rule',
      'prepayment-rule': 'Deposit Rule',
    },
    'cancellation-policy': {
      'description': 'The cancellation policy is visible on your public profile. Include the details you want your clients to know about no-showing and late cancellations.',
      'add-policy': 'Add Cancellation Policy',
    },
    'trusted-clients': {
      'description': 'You love all your clients, but those who have loyally returned to you and never left you hanging have earned the title of Trusted Client.<br><br> When you enable the Trusted Client feature for individual clients, they can book any time with no card, no Cancellation Fee and no Deposits. All they need is your trust in them!',
      'incrementer-title': 'No Cancellation Fee after',
      'incrementer-subtitle': 'completed appointments by the client',
    },
    'account-verification': {
      'title': 'Now let\'s verify your identity. ',
      'description': 'Identity verification is intended to protect you. We want to make sure that we\'re sending your payouts to a secure place.',
      'info': 'Please have a recent bank statement on hand along with your current address, Tax ID number (aka SSN), and a photo ID. This will help us match your identity to your bank account.',
      'resolve': 'Verify account',
    },
    'mobile-payments': {
      'title': 'First, you need Mobile Payments',
      'description': 'To use No-Show Protection you need to enable Mobile Payments',
      'resolve': 'Enable Mobile Payments',
    },
    'feature-info': {
      'title': 'Guarantee your income on your own terms and fully control your schedule',
      'resolve': 'Turn On',
    },
    'info-slider': {
      'main-title': 'Your Time Is Your Money',
      'prepayments-title': 'Deposits',
      'cancellation-fees-title': 'Cancellation Fees',
      'main-description': 'Protect both with Deposits and Cancellation Fees.',
      'prepayments-description': 'Charge your clients a portion of the service charge at the time of booking.',
      'cancellation-fees-description': 'Charge clients a set fee if they miss their appointment or cancel on short notice.',
    },
    'alert': {
      'message-deposit': 'Min. deposit: {amount}',
      'message-cancellation-fee': 'Min. cancellation fee: {amount}',
      'extended-message-deposit': 'Min. deposit: {amount}. Some services are not eligible with this rule. Adjust rule or create a new one for these services.',
      'extended-message-cancellation-fee': 'Min. cancellation fee: {amount}. Some services are not eligible with this rule. Adjust rule or create a new one for these services.',
      'max-message-deposit': 'Max. deposit: {amount}',
      'max-message-cancellation-fee': 'Max. cancellation fee: {amount}',
    },
  },
  'instagram-modal': {
    title: 'Instagram bookings',
    'link-in-bio': 'Link in bio',
    'book-now-button': 'Book now button',
    'add-booking-link': 'Add booking link to your bio',
    'copy-booking-link': 'Copy booking link',
    'open-instagram': 'Open Instagram on your phone',
    'switch-account-info': 'If you have a personal account, you’ll need to switch to a professional account.',
    'add-external-link-step': 'Select <b>Edit profile > Links > Add external link.</b>',
    'paste-link-step': 'Paste your booking link in the URL field and give it a title.',
    'get-book-now-button': 'Get Book now button on your profile',
    'add-action-button-step': 'Select <b>Edit profile > Contact options > Add an action button.</b>',
    'select-booksy-step': 'Select Booksy from the list.',
    'sign-in-booksy-step': 'Log in to Booksy with your email and password.',
    'continue-step': 'Tap <b>Continue</b> on the Connect to Instagram screen.',
  },
  instagram: {
    title: 'Instagram',
    instagram: 'Instagram',
    'instagram-description': 'Turn your followers into bookings by adding<br/>a "BOOK" button to your profile.',
    'guide-header': 'Step Guide',
    'guide-1': 'Make sure your Instagram account is set up<br/>as a business profile',
    'staff-member-guide-1': 'Make sure the Instagram account is set up as a Creator or Business profile',
    'book-now-guide-1': 'Make sure your Instagram account is set up as a Creator or Business profile',
    'guide-1-link': 'Click here to find out more',
    'guide-2': 'Go to your Instagram profile and click<br/>"Edit Profile"',
    'staff-member-guide-2': 'Go to the Instagram profile on a mobile device and click "Edit Profile"',
    'book-now-guide-2': 'Go to your Instagram profile on mobile device and click "Edit Profile"',
    'guide-3': 'Tap "Action Buttons" (under Public business information)',
    'guide-4': 'Tap "Book Now"',
    'guide-5': 'Select "Booksy" and sign in with your Booksy credentials',
    'staff-member-guide-5': 'Select "Booksy" and sign in with Booksy user credentials',
    'book-now-guide-5': 'Select "Booksy" and sign in with your Booksy user credentials',
    'guide-6': 'Click "Continue"',
    'guide-7': 'Go back to your profile and you\'re all set!',
    'book-now-guide-7': 'Go back to the profile and you\'re all set<br/><br/>Please note it may take up to 24 hours for the button to become visible on your profile',
    'staff-member-guide-7': 'Go back to the profile and you\'re all set<br/><br/>Please note it may take up to 24 hours for the button to become visible on the profile',
    'book-now-header': 'Add Book Now button to your account - step guide',
    'book-now-header-owner': 'Add "Book Now" button to your company account - step guide',
    'book-now-header-member': 'Add "Book Now" button to your staff member account - step guide',
    'book-now-description': '"Book Now" button on Instagram can only be associated with one Booksy Business profile.',
    'add-to-company': 'Add "Book Now" button to your company account',
    'add-to-member': 'Add "Book Now" button to your staff member account',
  },
  google: {
    'title': 'Reserve with Google',
    'google': 'Reserve with Google',
    'google-title-active': 'Let clients book and manage their appointments online',
    'google-title-inactive': 'Your business is not currently eligible for Reserve with Google',
    'google-description': 'Let clients book and manage their appointments online.',
    'not-allowed-guide-header': 'Why? Three possibilities:',
    'not-allowed-description': 'Your business is not currently<br/>eligible for Reserve with Google',
    'not-allowed-guide-1': 'Google may not support online booking<br/>in your country.',
    'not-allowed-guide-2': 'Google requires a business address<br/>to use Reserve.',
    'not-allowed-guide-3': 'Your business may fall under a Google-restricted business type.',
    'allowed-guide-1': 'Claim your business on Google if you haven\'t already',
    'allowed-guide-2': 'Verify that your Google business address matches your Booksy address',
    'allowed-guide-3': 'Enable Reserve with Google by pressing the button at the bottom of the screen',
    'allowed-guide-4': 'Allow up to 48 hours for the "Book Now" button to appear on your Google profile',
    'guide-header': 'Step Guide',
    'extra-guide-title': 'Make sure your Instagram account is set up<br/>as a business profile',
    'extra-guide-description': 'Google Support: Add or claim your business listing ↗',
    'active-description': 'Let clients book with you directly from Google Search and Maps! These appointments will appear in your Booksy calendar.<br/><br/>If you don\'t see the option to book with your business after 72 hours of enabling, double check your entered street address and Google\'s business restrictions.',
    'connect-btn': 'Enable Reserve with Google',
    'disconnect-btn': 'Disable Reserve with Google',
    'business-restrictions': 'Google\'s business restrictions',
  },
  website: {
    'title': 'Website',
    'website': 'Website',
    'website-description': 'Easily add a Book button to your website',
    'add-widget-description': 'To add a booking button to your website, copy and paste following code on your website',
    'book-label': 'Book button code',
    'copy-to-clipboard': 'Copy to clipboard',
  },
  facebook: {
    'title': 'Facebook',
    'facebook': 'Facebook',
    'facebook-description': 'Allow your fans to book an appointment<br/>directly from your Facebook page.',
    'connect-description': 'To add Facebook “Book Now” button to your fanpage,<br/>just click button.',
    'connect-facebook-description': 'To add Facebook "Book Now" button to your fanpage, just click button below. ',
    'connect-title': 'Allow your fans to book appointments directly from your Facebook page',
    'connect-btn': 'Connect with Facebook',
    'disconnect-btn': 'Disconnect from facebook',
    'manage-extention': 'Manage Facebook business extension',
  },
  yelp: {
    'title': 'Yelp',
    'yelp': 'Yelp',
    'yelp-description': 'Allows clients to book an appointment<br/>directly from your Yelp profile.',
    'connect-description': 'To connect your Yelp listing with Booksy profile,<br/>just click button.',
    'connect-btn': 'Enable booking with yelp',
    'disconnect-btn': 'Disconnect from yelp',
  },
  hint: {
    'title': 'Online Booking',
    'description': 'Say bye-bye to interruptions, double-bookings, no-shows and so many more frustrations with the Booksy client app. Clients will see your availability and easily book you, while new clients can discover your business and make their first appointment.',
  },
  amenities: {
    title: 'Select from the list',
  },
  services: {
    title: 'Services',
  },
  'add-ons': {
    'title': 'Add-ons',
    'search-in-add-ons': 'Search in add-ons',
    'empty-state-title': 'No add-ons added yet.',
    'empty-state-description': 'Create add-ons and offer them together with your sevices.',
    'empty-search-title': 'No add-ons found',
    'services-modal-title': 'Add-on valid for Services',
    'list': {
      'select-add-ons-title': 'Select add-ons',
      'new-add-on': 'New add-on',
      'empty-state-title': 'No add-ons yet',
      'empty-state-description': 'Create add-ons once and link them to many services – think \'Nail art\' for manicures or \'Hot towel\' for barbers.',
    },
    'edit': {
      'new-title': 'Add Add-on',
      'edit-title': 'Edit Add-on',
      'add-next': 'Save & Add Next ADD-ON',
      'valid-for': 'Valid for',
      'add-services': 'Add services',
      'name': 'Add-on Name',
      'price': 'Price',
      'price-type': 'Price Type',
      'price-description': 'Description (optional)',
      'add-media': 'Add media',
      'details': 'Details',
      'toggler': 'Allow clients to book online',
      'max-quantity': 'Add-ons limit per service',
      'tax_rate': 'Tax rate',
      'not-set': 'Not Set',
      'upload-new-photo': 'Upload new photo',
      'remove-photo': 'Remove photo',
      'photo-modal-title': 'Delete photo?',
      'photo-modal-description': 'This cannot be undone',
      'add-on-modal-title': 'Delete Add-on?',
      'add-on-modal-description': 'This cannot be undone',
      'price-description-hint': 'Use short (max. 55 char.) description. <br> E.g. „per nail”, „for 1 piece”.',
    },
  },
  'advanced-options': {
    'search': 'Search in Advanced Options...',
  },
  'loyalty-program': {
    'new-badge': 'new',
    'share-on-social-media': 'Share post about program',
    'enable-loyalty-program': {
      'description': 'Reward your clients for their loyalty. Create custom loyalty cards so your clients can earn stamps and redeem them for a discount, free service or product. <br><br> Choose what works best for your business, including the final reward.',
      'enable': 'Enable Loyalty program',
    },
    'modals': {
      'delete-expired-cards': {
        'title': 'Delete Expired Cards',
        'description': 'All expired cards will be voided and deleted. These cards will be removed permanently. This can\'t be reversed.',
        'action-delete': 'Delete Expired Cards',
      },
      'delete-completed-cards': {
        'title': 'Delete Completed Cards',
        'description': 'All completed cards will be voided and deleted. Any stamps the client had earned will be permanently voided. This can\'t be reversed.',
        'action-delete': 'Delete Completed Cards',
      },
      'void-all-loyalty-cards': {
        'title': 'Delete All Loyalty Cards',
        'description': 'All Loyalty Cards (active, completed, and expired) will be deleted. Any stamps or rewards the client has earned will be permanently deleted. This can\'t be reversed.',
        'action-delete': 'Delete All Cards',
      },
    },
    'cards': {
      'loyalty-card': 'Loyalty Card',
      'loyalty-cards': 'Loyalty Cards',
      'manage-cards': 'Manage Cards',
      'search-placeholder': 'Search by client name',
      'lp-disabled': 'Loyalty Program is disabled so you can\'t issue new cards.',
      'no-results': 'No results found...',
      'status-activated': 'Activated',
      'status-completed': 'Completed',
      'status-redeemed': 'Redeemed',
      'status-expired': 'Expired',
      'status-inactive': 'Inactive',
      'delete-expired-cards': 'Delete Expired Cards',
      'delete-completed-cards': 'Delete Completed Cards',
      'void-all-loyalty-cards': 'Delete All Loyalty Cards',
      'appointment': 'Appointment',
      'change': 'Change',
      'redeemed': 'Redeemed',
      'completed': 'Completed',
      'card-issue': 'Card issue',
      'form': {
        'add-card': 'Add Loyalty Card',
        'edit-card': 'Edit Card',
        'balance': 'Balance',
        'expiration-date': 'Expiration date',
        'issue-date': 'Issue date',
        'card-holder': 'Card Holder',
        'customer-name': 'Customer Name',
        'reward': 'Reward',
        'minimum-value-stamps': 'Minimum value to earn stamps',
        'stamp-deadline': 'Stamp Deadline',
        'reward-expiration': 'Reward Expiration',
        'card-history': 'Card History',
        'history-no-results': 'This Loyalty Card doesn\'t have any transaction history yet.',
        'current-balance': 'Current Balance',
        'card-status': 'Card Status',
        'stamps': 'Stamps',
        'void-card': 'Void Card',
        'void-card-title': 'Are you sure?',
        'void-card-description': 'If you void this Loyalty Card, it cannot be reversed. Your client will lose any stamps or rewards they may have earned.',
        'issue-reward': 'Issue Reward',
        'client-earned-reward': 'Your client earned their reward!',
        'yes-void': 'Yes, Void',
        'time-period-form-last-appointment': 'time period from last qualifying appointment',
        'reward-expiration-date': 'Reward expiration date',
        'card-voided': 'Card Voided',
      },
    },
    'settings': {
      'title': 'Settings',
      'terms': 'Terms & Conditions',
      'craft-terms-and-conditions': 'Craft the Terms & Conditions for your Loyalty Program.',
      'terms-label': 'Loyalty Program Terms & Conditions',
      'loyalty-card-type': {
        'stamps': 'Stamps',
      },
      'score-calculation': {
        'title': 'Stamp',
        'after-appointment': 'After appointment is complete',
        'after-appointment-description': 'The client will earn stamps based on the value of the completed appointment. Checkout is not required for the client to receive stamps.',
        'after-checkout': 'After Checkout is complete',
        'after-checkout-description': 'The client will earn stamps based on the value of the appointment. Checkout is required for the client to receive stamps.',
      },
      'card-expiration-mode': {
        'never': 'Never',
        'from-card-issue': 'From card issue date',
        'from-last-appointment': 'From last appointment',
        'select-date': 'Select a date',
        'select-a-time-last-appointment': 'Select a time period from last qualifying appointment',
      },
      'min-value-score-options': {
        'never': 'Never',
        'three-month': '3 Months',
        'six-month': '6 Months',
        'one-year': '1 Year',
        'two-year': '2 Years',
        'select-date': 'Select a date',
      },
      'loyalty-card-design': {
        'title': 'Loyalty card design',
        'add-custom-design': 'Add custom design',
        'error-not-selected-image': 'No image selected',
      },
      'loyalty-program-success': {
        'title': 'Loyalty Program is Enabled',
        'description': 'Now that Loyalty Program is enabled, you can create Loyalty Cards. Your clients will be able to manage their Loyalty Cards from their Booksy app.',
      },
      'loyalty-program-update': {
        'title': 'Keep existing cards before saving?',
        'description': 'Existing loyalty cards preserve your original settings. You can choose to keep those cards, but the updated settings will only apply to new cards.<br><br>Deleting cards will be permanent and clients will lose stamps or rewards.',
        'saveAndKeep': 'Keep existing cards',
        'saveAndVoid': 'Delete existing cards',
        'cancel': 'Go back',
      },
      'disable-loyalty-program': {
        'title': 'Disable Loyalty Program?',
        'description': 'If you disable Loyalty Program, Loyalty Cards will be hidden from your clients and they\'ll no longer be able to manage their Loyalty Cards from the Booksy app. <br><br>Clients will no longer be able to collect stamps. Their Loyalty Card balance will be saved, but they will not be able to redeem stamps for rewards. They will be able to use any existing rewards until the Reward Expiration Date.',
      },
      'settings-form': {
        'type': 'Loyalty Card Type',
        'reward-name': 'Reward',
        'total-stamps': 'Total stamps',
        'free-stamps': 'Free stamps',
        'free-stamp-description': 'Get your clients motivated to earn stamps by giving away a freebie. If you don\'t want to give any freebies, choose 0. Free Stamps can\'t be more than the Total Stamps.',
        'minimum-value-to-score': 'Minimum value to earn stamp',
        'stamps-deadline': 'Stamp Deadline',
        'reward-expiration': 'Reward Expiration',
        'card-expiration': 'Card Expiration',
        'stamp-awarded': 'Stamp Awarded',
        'auto-new-client': 'Issue automatically to new clients',
        'auto-new-and-existing-client': 'Issue loyalty cards automatically',
        'auto-new-and-existing-client-hint': 'Current and new clients will get loyalty cards on their accounts. Uncheck this option to issue cards manually instead.',
        'auto-new-client-hint': 'Each new client on the merchant client base gets the loyalty card issued as the program is activated.',
        'edit-card-design': 'Edit Card Design',
        'stamp-error-message': 'Stamps between 0 and {maxStamps}',
      },
    },
  },
  'splash-screens': {
    'stripe-add-payout-details': {
      'title': 'Add payout details',
      'description': 'Add your bank account or card information to receive payouts.',
      'lists': {
        'item-1': 'Add bank account details for standard payouts',
        'item-2': 'Add debit card for Fast Payouts ',
        'item-3': 'Update payout details at any time in Payout Settings',
      },
      'add-payout-details-btn': 'Add payout details',
      'not-now': 'Not now',
      'fr': {
        'description': 'Add your bank account information to receive payouts.',
        'lists': {
          'item-1': 'Add bank account details for standard payouts',
          'item-2': 'Update payout details at any time in Payout Settings',
        },
      },
    },
    'subscription': {
      'subscribe-info': 'To get started using Booksy Payments, select the Booksy subscription plan that works best for your business.',
      'buttons': {
        'subscribe': 'Subscribe to Booksy',
      },
      'account-verification': {
        'title': 'Verify your account',
        'description': {
          'bcr': 'Take these easy steps to verify your account and get Mobile Payments, No-Show Protection, and the ability to order and set up your Booksy Card Reader.<br><br><strong>To get started using Booksy Payments, select the Booksy subscription plan that works best for your business.</strong>',
          'default': 'Take these easy steps to verify your account and get Mobile Payments and No-Show Protection.<br><br><strong>To get started using Booksy Payments, select the Booksy subscription plan that works best for your business.</strong>',
        },
      },
      'tap-to-pay': {
        'title': 'Tap to Pay',
        'description': {
          'default': 'Accept contactless payments from physical cards and digital wallets – no extra hardware required.',
          'part-2': 'To get started using Tap to Pay, select the Booksy subscription plan that works best for your business.',
        },
        'lists': [
          'Fast and simple in-person payments',
          'Track everything in one app',
          'Available for most <u>devices</u>',
        ],
      },
      'mobile-payments': {
        'title': 'Accept Mobile Payments',
        'description': {
          'default': 'No more switching back and forth between apps at Checkout, and you can offer your clients a variety of payment options. It\'s a win-win.<br><br><strong>To get started using Booksy Payments, select the Booksy subscription plan that works best for your business.</strong>',
        },
      },
      'no-show-protection': {
        'title': 'Enable No-Show Protection',
        'description': {
          'default': 'You work hard and you deserve to get paid for your time and effort. Use Deposits and Cancellation Fees to limit no-shows, late cancellations, and prevent revenue loss.<br><br><strong>To get started using No-Show Protection, select the Booksy subscription plan that works best for your business.</strong>',
        },
      },
      'booksy-card-reader': {
        'title': 'The better way to get paid',
        'description': 'Booksy Card Reader lets you process card and mobile wallet payments on the spot. It’s quick, secure and easy.<br><br>No more switching back and forth between apps. Offer your customers a seamless experience at Checkout with the fully integrated Booksy Card Reader.<br><br><strong>To get started using Booksy Card Reader, select the Booksy subscription plan that works best for your business.</strong>',
      },
    },
    'enable-feature': {
      'buttons': {
        'get-started': 'Get started',
        'update-verification-details': 'Update verification details',
      },
      'account-verification': {
        'title': 'Verify your account',
        'description': {
          'bcr': 'Take these easy steps to verify your account and get Mobile Payments, No-Show Protection, and the ability to order and set up your Booksy Card Reader.',
          'default': 'Take these easy steps to verify your account and get Mobile Payments and No-Show Protection.',
        },
        'lists': [
          'Setup your account with {provider}',
          'Protect your bottom line with No-Show Protection',
          'Track everything in one app',
        ],
        'disclaimer': 'In the unlikely event one of your customers opens a dispute with their bank you\'ll be responsible for a $15 non-refundable chargeback fee. By clicking “Get started” you are agreeing to the <a href="https://stripe.com/legal/connect-account"><strong>Connected Account Agreement.</strong></a> The process will be completed via Stripe.',
      },
      'tap-to-pay': {
        'title': 'Tap to Pay',
        'description': {
          'default': 'Accept contactless payments via your mobile device from physical cards and digital wallets – no extra hardware required.',
        },
        'lists': [
          'Fast and simple in-person payments',
          'Track everything in one app',
          'Available for most <u>devices</u>',
        ],
        'toast': 'Tap to Pay activated. Please complete the setup on your mobile device.',
        'disclaimer': 'By clicking “Get started” you are agreeing to the <a href="https://stripe.com/legal/connect-account"><strong>Connected Account Agreement.</strong></a> The process will be completed via Stripe.',
      },
      'mobile-payments': {
        'title': 'Accept Mobile  Payments',
        'description': {
          'default': 'Set up Mobile Payments to let clients pay directly from their Booksy app, as well as paying for Gift Cards, collecting Deposits or Cancellation Fees to protect against no-shows.',
        },
        'lists': [
          'Quick and easy setup',
          'Protect your bottom line with No-Show Protection',
          'Track everything in one app',
        ],
        'terms-stripe': 'By clicking “Get started” you are agreeing to the <a href="https://stripe.com/legal/connect-account" target="_blank"><strong>Connected Account Agreement.</strong></a> The process will be completed via Stripe.',
      },
      'no-show-protection': {
        'title': 'Make your time count',
        'description': {
          'default': 'You work hard and you deserve to get paid for your time and effort. Use Deposits and Cancellation Fees to limit no-shows, late cancellations, and prevent revenue loss.',
        },
        'lists': [
          'Verify your account',
          'Set Deposits and Cancellation Fees',
          'Let clients pay using their Booksy app',
        ],
        'terms-stripe': 'By clicking “Get started” you are agreeing to the <a href="https://stripe.com/legal/connect-account" target="_blank"><strong>Connected Account Agreement.</strong></a> The process will be completed via Stripe.',
      },
      'booksy-card-reader': {
        'title': 'Getting paid, made easy',
        'description': 'Booksy Card Reader lets you accept card and mobile wallet payments on the spot. Giving your customers flexible payment options means it\'s easier for you to get paid.',
        'description-pending': 'Greater flexibility for your customers means it\'s easier for you to get paid.',
        'lists': [
          'Simple set up',
          'Low, transparent processing fees',
          'One app for everything',
        ],
        'disclaimer': 'By clicking “Get started” you are agreeing to the <a href="https://stripe.com/legal/connect-account" target="_blank"><strong>Connected Account Agreement.</strong></a>',
      },
      'booksy-gift-cards': {
        'title': 'Start accepting Booksy Gift Cards',
        'description': 'Join thousands of businesses already enjoying the benefits of Booksy Gift Cards. Gain a new revenue stream and attract new clients to your business.',
        'btn-subscribe': 'Subscribe to Booksy',
        'btn-learn-more': 'Learn more',
        'btn-get-started': 'Get started',
        'btn-kyc-details': 'Update verification details',
        'btn-update-verification-details': 'Update verification details',
        'cards': {
          'card-1': {
            'title': 'Attract new clients',
            'text': 'Gift card recipients often look for new places to redeem their cards. This opens the door to a wider audience—turn these new visitors into loyal clients!',
          },
          'card-2': {
            'title': 'Keep your calendar full',
            'text': 'Clients buy gift cards during popular gifting seasons, and recipients tend to redeem them during off-peak times. This helps keep your calendar consistently busy year-round.',
          },
          'card-3': {
            'title': 'Stand out in the Booksy app',
            'text': 'Your profile will get a special badge and will be featured in search results among providers who accept Booksy Gift Cards. Potential clients will easily find you!',
          },
          'card-4': {
            'title': 'Increase your revenue',
            'text': 'Unlock extra revenue without any extra work—we handle all the Gift Card admin and promotion. Plus, Gift Card bookings typically bring in higher value appointments.',
          },
        },
        'steps': {
          'title': 'Check out appointments with Gift Cards in 4 easy steps',
          'step-1': {
            'title': 'Click Checkout',
            'text': 'Go to appointment details in your calendar and select <strong>Checkout</strong>.',
          },
          'step-2': {
            'title': 'Select Gift Card as payment method',
            'text': 'Select <strong>Checkout with Gift Gard</strong>. This step is required to receive funds from a Gift Card.',
          },
          'step-3': {
            'title': 'Add other payment methods (optional)',
            'text': 'If the service costs more than the amount on the Gift Card, check out the remaining balance using other payment methods.',
          },
          'step-4': {
            'title': 'Receive money fast',
            'text': 'Funds from Booksy Gift Card will be paid out to your account on the next business day.',
          },
        },
        'how-it-works': {
          'title': 'How does Booksy Gift Card work?',
        },
        'fees': {
          'title': 'No hidden costs',
          'subtitle': 'You only pay a processing fee when Gift Cards are redeemed. Enjoy transparent rates with no monthly fees.',
          'processing-fee-trx': 'Booksy Gift Card usage fee',
          'example': 'Example',
          'appointment-value': 'Appointment value',
          'gc-value': 'Gift Card value',
          'processing-fee': 'Booksy fee (gross)',
          'you-receive': 'You receive:',
        },
      },
      'booksy-pay': {
        'activation': {
          'title': 'Booksy Pay: Focus on your clients, not the checkout',
          'description': 'Offer clients a new way to pay. With Booksy Pay, they can pay how they like—upfront or after their appointment—with a card, BLIK, Apple Pay, Google Pay, and Klarna.',
          'features': [
            {
              'title': 'Get additional protection against no-shows',
              'text': 'Based on our data, bookings with Booksy Pay are canceled up to 90% less often.',
            },
            {
              'title': 'Make tipping seamless and stress-free',
              'text': '1 in 3 clients tip digitally with Booksy Pay.',
            },
            {
              'title': 'No extra hardware or setup fees',
              'text': 'It\'s built right into the app, without extra hardware.',
            },
          ],
          'price-info-title': '0 zł for 12 months',
          'price-info-disclaimer': 'From the activation date',
          'additional-info': 'Cancel anytime • No hidden fees',
          'enable-button': 'Enable Booksy Pay',
          'success-message': 'Booksy Pay activated',
          'kyc-modal': {
            'title': 'Further action required',
            'text': 'It looks like we need a bit more information to get you set up on Booksy Pay. Please take a couple moments to verify your account and confirm all information is correct.',
            'verify-account-button': 'Verify your account',
          },
        },
        'status': {
          'active': 'Active',
          'new': 'New',
        },
        'title': 'Booksy Pay: seamless in-app payments',
        'description': 'Booksy Pay lets clients pay upfront when booking — giving them a smoother experience while securing your earnings, protecting against no-shows as well as adding a new way to receive tips.',
        'btn-learn-more': 'Learn more',
        'fees': {
          'free': {
            'title': '0% processing fee',
            'text': 'You receive the full payment amount',
          },
        },
        'cards': {
          'card-1': {
            'title': 'Additional protection against no-show clients',
            'text': 'Bookings made with Booksy Pay are canceled up to 90% less often, on average.',
          },
          'card-2': {
            'title': 'Most convenient payment method',
            'text': 'Clients can pay their way, quickly and securely, directly in the app. You’ll save time by no longer needing to handle appointment checkouts.',
          },
          'card-3': {
            'title': 'Increased visibility and client benefits',
            'text': 'When you enable Booksy Pay, you\'ll earn a special in-app badge, and your clients can enjoy exclusive cashback promotions and Booksy-funded discounts.',
          },
          'card-4': {
            'title': 'More ways to receive tips',
            'text': 'Booksy Pay adds a new way for clients to add tips. No cash? No problem. About one in three transactions include a tip made with Booksy Pay.',
          },
        },
        'steps': {
          'title': 'How it works?',
          'step-1': {
            'text': 'A special badge highlights your business as a Booksy Pay provider, making it easy for clients to find you. ',
          },
          'step-2': {
            'text': 'Clients can pay securely through the app when booking or later, though most choose to pay upfront.',
          },
          'step-3': {
            'text': 'Paid appointments are clearly marked with a dollar sign in your calendar.',
          },
          'step-4': {
            'text': 'You receive your funds the next business day after payment, regardless of the appointment date.',
          },
        },
        'faq': {
          'title': 'FAQ',
          'questions': [
            {
              'question': 'What is the difference between Booksy Pay, Mobile Payments, and Deposits?',
              'answer': '<strong>Booksy Pay</strong> is a convenient payment method that allows clients to pay the full appointment cost upfront through the app. Payments can be made from 10 days before the appointment and up to 2 hours after, using a payment card, Apple Pay, Google Pay, or BLIK. Clients are also able to add a tip to their payment with Booksy Pay.<br/><br/>Mobile Payments also allow cashless payments for appointments, but only after the appointment is completed. Clients cannot initiate payments in advance with Mobile Payments, and collecting payment in advance has been shown to significantly reduce the risk of cancellation.<br/><br/>Deposits serve as protection against last-minute cancellations or no-shows. Businesses can set a custom percentage of the service price as a deposit, which is collected at the time of booking.<br/><br/>Each option has different commission rates—check the app for details.',
            },
            {
              'question': 'When will I receive the money for an appointment paid with Booksy Pay?',
              'answer': 'Funds from Booksy Pay will be deposited into your linked bank account <strong>within one business day</strong>. If a client books and pays upfront, you may receive the money several days before their appointment.<br/><br/>Each time a client pays using Booksy Pay, you’ll receive a payment notification. A payment confirmation icon will also appear on the appointment tile in your calendar, along with a Paid label in the appointment details.',
            },
            {
              'question': 'Can clients pay for every appointment via Booksy Pay?',
              'answer': `No, clients cannot pay for every appointment via Booksy Pay. Payment through Booksy Pay is only possible for appointments that meet specific conditions.
              <br/><br/>
              Booksy Pay payment conditions:
              <ul>
                <li>Service without deposit/cancellation fee: The service a client books cannot require a deposit or cancellation fee.
                  <ul>
                    <li>Exception: A trusted client can pay via Booksy Pay for a service with a deposit or cancellation fee set.</li>
                  </ul>
                </li>
                <li>Fixed price and minimum amount: The service must have a "Fixed" price type and cost at least 10 PLN.</li>
                <li>Booking without Booksy Gift Card: The booking cannot be made using a Booksy Gift Card.</li>
                <li>Confirmed Appointment: The appointment must be confirmed.</li>
              </ul>
              <br/><br/>
              Payment via Booksy Pay is available for appointments booked by clients in the app, as well as those added by the business. Clients can pay from 10 days before the appointment up to 2 hours after it ends.`,
            },
            {
              'question': 'How can I track Booksy Pay transactions?',
              'answer': `You have several convenient ways to track your Booksy Pay transactions:
              <br/><br/>
              <ul>
                <li><strong>Booksy Wallet Transactions History:</strong> All your Booksy Payments transactions, including Booksy Pay payments and refunds, are visible in your Booksy Wallet in the Transactions tab. This can serve as your primary on-the-go reporting tool for basic checks like payment sources and refund statuses. Filters will soon be available to help you pinpoint specific transactions more easily.</li>
                <li><strong>Mobile Payments Transactions Summary report (available on web/tablet):</strong> For a comprehensive overview, Booksy Pay transactions (including refunds) are part of the Mobile Payments Transactions Summary report. You can find this report by navigating to Reports > Cash flow > Mobile payments transaction summary on the web version of Booksy.</li>
                <li><strong>Detailed Report (available on mobile):</strong> For in-depth analysis, a detailed Excel file of your transactions, including those processed via Booksy Pay, is available for download directly from the Booksy mobile app. You can download this report by navigating to Profile > Performance Summary section > Detailed report.</li>
              </ul>`,
            },
            {
              'question': 'What if the final amount due for an appointment is different from the amount paid with Booksy Pay?',
              'answer': '<strong>If the final amount is higher</strong>, collect the remaining balance from the client. You can either edit the original booking amount or add a new item to adjust the total due.<br/><strong>If the final amount is lower</strong>, issue a partial refund through Booksy. To do this, go to the appointment tile, click the <strong>Paid</strong> label, and select <strong>Refund</strong>. Select the <strong>Partial refund</strong> option, enter the <strong>refund amount</strong>, select <strong>Refund payment</strong>, and confirm with <strong>Issue refund</strong>.',
            },
            {
              'question': 'Do I need to issue a receipt for appointments paid with Booksy Pay?',
              'answer': 'Yes, you should issue a receipt after the appointment is completed. <strong>Booksy does not automatically generate</strong> receipts—the client will receive a payment confirmation email, but this is not a fiscal receipt.',
            },
          ],
        },
        'refunds': {
          'title': 'Booksy Pay refunds',
          'description': 'When a client cancels a Booksy Pay prepaid appointment, we help ensure a smooth refund process for everyone, saving you time.',
          'on-time-cancellations': {
            'title': 'On-time cancellations',
            'description': 'If a client cancels a prepaid appointment before your late cancellation window, the refund is processed automatically.',
            'instructions': [
              'The refund amount will be deducted from your Booksy Payments balance.',
              'You\'ll find a complete history of refunds in your Booksy Wallet transaction list.',
              'We\'ll send you a push notification once the refund is complete. On the receipt, automatic refunds will be marked as processed by system.',
            ],
          },
          'late-cancellation-window': {
            'title': 'Set your late cancellation window',
            'description': 'Define how far in advance clients need to cancel to receive an automatic refund. If a client cancels after this cut-off, you decide whether to issue the refund.',
            'label': 'Late cancellation window',
            'save': 'Save',
            'success-message': 'Late cancellation window set',
          },
          'late-cancellations': {
            'title': 'Late cancellations',
            'description': 'If a client cancels within your late cancellation window, you decide whether to issue a refund.',
            'instructions': [
              'When clients cancel late, they’re notified that you\'ll decide on the refund.',
              'You’ll get a push notification about the client\'s refund request.',
              'You can approve the refund from the receipt in appointment details—just click the cancellation notification to go there. You have 30 days from the request to make a decision.',
            ],
          },
          'refund-statuses': {
            'title': 'Refund statuses visible to clients',
            'sent-for-refund-label': 'Sent for refund',
            'sent-for-refund-description': 'We\'ve started the refund process. Clients see this status for just a short time.',
            'refund-requested-label': 'Refund requested',
            'refund-requested-description': 'The client canceled late. The refund awaits your decision.',
            'refunded-label': 'Refunded',
            'refunded-description': 'The refund has been processed. Funds should appear in their account within 1-3 business days.',
            'refund-overdue-label': 'Refund overdue',
            'refund-overdue-description': 'Your 30-day window to decide on a refund for this late cancellation has expired.',
          },
        },
      },
    },
    'splash-no-shows': {
      'title': 'How much do canceled appointments cost you?',
      'description': 'Clients who don\'t show up for their appointments create gaps in your calendar, resulting in lost potential earnings. Enabling deposits allows you to protect your revenue and reduce these gaps.',
      'cards': ['Canceled appointments*', 'Lost revenue**'],
      'messages': ['* average from last 3 months', '** total sum of late cancellations and no-shows'],
      'enable-deposits': 'Enable deposits',
      'disclaimer': 'Data has been collected based on the analysis of the value of your appointments and calendar occupancy during the last 3 months. For fees and commissions, see the <a href="{link}" target="_blank"><strong>Terms of Service</strong></a> of The Booksy BIZ application',
    },
    'deposit': {
      'title': 'Keep the extra protection in place?',
      'description': 'Your deposit amount is scheduled to return to its pre-holiday level. The higher amount has helped you secure more reliable bookings and reduce the risk of late cancellations. Now that you\'ve tried it, would you like to keep it at this level to maintain the added protection?',
      'cards': {
        'current-value': 'Current deposit amount',
        'suggested-value': 'Suggested deposit amount',
      },
      'message': 'Changing the deposit amount will automatically apply it to all covered services. You can change the deposit amount at any time in settings.',
      'incrementer': 'Select deposit amount',
      'apply': 'Apply changes',
      'go-to-settings': 'Go to settings',
      'decision': {
        'title': 'Apply change:',
        'until': 'Until {date}',
        'forever': 'Permanently',
      },
    },
    'modals': {
      'tap-to-pay': {
        'devices': {
          'title': 'List of supported devices',
          'description': 'The devices listed below are confirmed to meet the current hardware and minimum OS requirements.',
        },
      },
    },
  },
}
